module.exports = {
  "3": "ja-jp",
  "2": "zh-cn",
  "4": "zh-tw"
};